import Vue from 'vue'
export const EventBus = new Vue()

// available events
export const CART_UPDATED = 'CART_UPDATED'
export const PHARMACY_UPDATED = 'PHARMACY_UPDATED'
export const SET_LOADER = 'SET_LOADER'
export const CUSTOMER_DATA_UPDATED = 'CUSTOMER_DATA_UPDATED'
